import React from 'react';
import { Card } from 'react-mdl/lib/Card';
import { t } from '../lang/trans.js';
import Icon from 'react-mdl/lib/Icon';

export default () => {
  return (
    <Card shadow={0} style={{ minHeight: 0, width: '100%' }}>
      <div style={{ textAlign: 'center', fontSize: '1.3em', padding: '18px' }}>
        <Icon name="train" style={{ fontSize: '40px' }} />
        <br/>
        {t('no trains')}
      </div>
    </Card>
  );
};



/** WEBPACK FOOTER **
 ** ./src/components/NoTrainResults.js
 **/